import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=ef41c380&scoped=true"
import script from "./Entity.vue?vue&type=script&lang=js"
export * from "./Entity.vue?vue&type=script&lang=js"
import style0 from "./Entity.vue?vue&type=style&index=0&id=ef41c380&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef41c380",
  null
  
)

export default component.exports